import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useQuestionsStore = create(
  persist(
    (set) => ({
      storeAnswers: {},
      setStoreAnswers: (payload) => set((state) => ({ storeAnswers: payload })),
    }),
    {
      name: "multiplyonboarding_answers",
      partialize: (state) => ({
        storeAnswers: state.storeAnswers,
      }),
    }
  )
);
